import { Popover, PopoverProps, styled } from "@mui/material";

export const ArrowPopover = styled(Popover)<PopoverProps>(() => ({
	"& .MuiPaper-root": {
		"&::before": {
			content: '""',
			display: "block",
			width: 16,
			height: 16,
			backgroundColor: "#f6f4fb",
			borderTop: "1.5px solid #e4e4e4",
			borderLeft: "1.5px solid #e4e4e4",
			transform: "translateY(-50%) rotate(45deg)",
			position: "absolute",
			top: 0,
			left: 50,
			zIndex: 0,
		},
	},
}));
